import { MultiProcessOfferDto } from '@/api/generated';

import { PdfOfferScope } from './useProcessOfferPdfPreview.util.ts';

export type OfferPrintTemplateTarget =
  | { level: 'group'; offerPrintId?: number; offerPrintName?: string }
  | {
      level: 'offer';
      offerPrintId?: number;
      offerPrintName?: string;
      processOfferId: string;
    };

export const resolveOfferPrintTemplateTarget = (
  scope: PdfOfferScope,
  processOfferId: string,
  processMultiOffer?: MultiProcessOfferDto,
): OfferPrintTemplateTarget => {
  const group = {
    level: 'group' as const,
    offerPrintId: processMultiOffer?.offerPrintId,
    offerPrintName: processMultiOffer?.offerPrintName,
  };

  if (scope === 'all') {
    return group;
  }

  const offer = processMultiOffer?.processOffers?.find(it => it.processOfferId === processOfferId);

  return offer?.offerPrintId == null
    ? group
    : {
        level: 'offer',
        offerPrintId: offer.offerPrintId,
        offerPrintName: offer.offerPrintName,
        processOfferId,
      };
};
